import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { BaseDataService } from './base-data-service';
import { OktaConfig } from '@okta/okta-angular';
import { OKTA_CONFIG } from '@okta/okta-angular';
import { appendRelativePathToUrl } from '@tmhcc/util';
import { GlobalVariablesService } from './global-variables.service';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordEmailValidService extends BaseDataService {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    @Inject(OKTA_CONFIG) protected configs: OktaConfig,
    protected globalVariables: GlobalVariablesService
  ) {
    super(http, configService, globalVariables);
  }

  emailValid() {
    const url = this.getConfigUrl('configuration/AEPO');
    return this.get<any>(url);
  }

  getConfigUrl(servicePath: string): string {
    return appendRelativePathToUrl(
      this.configService.config.dataServiceBaseUrl,
      servicePath
    );
  }
}
